import { render, staticRenderFns } from "./TabDetails.vue?vue&type=template&id=5ac79322"
import script from "./TabDetails.vue?vue&type=script&lang=ts"
export * from "./TabDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports